import React from 'react';
import { BaseButton } from '@common/components';

export const CancelButton = (props: { onClick: () => void }) => (
  <BaseButton onClick={props.onClick}>Cancel</BaseButton>
);
